import { useCallback, useState } from 'react';
import { useToggler } from '@cbhq/cds-common';

import useProjectNavigation from ':cloud/hooks/useProjectNavigation';
import { EventName, logClick } from ':cloud/init/clientAnalytics/logging';
import { Token } from ':cloud/widgets/access/api/Token';
import { TokenConfigureModal } from ':cloud/widgets/access/api/TokenConfigureModal';
import { TokenRotateModal } from ':cloud/widgets/access/api/TokenRotateModal';
import { Layout } from ':cloud/widgets/layout';
import { MAIN_CONTAINER_MIN_WIDTH } from ':cloud/widgets/product/constants';
import { CloudErrorBoundary } from ':cloud/widgets/sharedcomponents';

export function ClientAPIKey() {
  useProjectNavigation();

  const [rotateModalVisible, { toggleOn: toggleRotateModalOn, toggleOff: toggleRotateModalOff }] =
    useToggler(false);
  const [
    configureModalVisible,
    { toggleOn: toggleConfigureModalOn, toggleOff: toggleConfigureModalOff },
  ] = useToggler(false);
  const [tokenId, setTokenId] = useState('');

  const handleRotateRequest = useCallback(
    (clientId: string) => {
      logClick(EventName.client_key_rotate_click);
      setTokenId(clientId);
      toggleRotateModalOn();
    },
    [toggleRotateModalOn],
  );

  const handleRotateToken = useCallback(() => {
    setTokenId('');
    toggleRotateModalOff();
  }, [toggleRotateModalOff]);

  const handleConfigureRequest = useCallback(
    (clientId: string) => {
      logClick(EventName.client_key_configure_click);
      setTokenId(clientId);
      toggleConfigureModalOn();
    },
    [toggleConfigureModalOn],
  );

  const handleConfigureToken = useCallback(() => {
    setTokenId('');
    toggleConfigureModalOff();
  }, [toggleConfigureModalOff]);

  return (
    <Layout>
      <Layout.MainContainer fullWidth minWidth={MAIN_CONTAINER_MIN_WIDTH}>
        <CloudErrorBoundary name="ClientAPIKey" isComponentLevel>
          {rotateModalVisible && (
            <TokenRotateModal
              tokenId={tokenId}
              onRequestClose={toggleRotateModalOff}
              onSuccess={handleRotateToken}
            />
          )}
          {configureModalVisible && (
            <TokenConfigureModal
              tokenId={tokenId}
              onRequestClose={toggleConfigureModalOff}
              onSuccess={handleConfigureToken}
            />
          )}
          <Token onRotatePress={handleRotateRequest} onConfigurePress={handleConfigureRequest} />
        </CloudErrorBoundary>
      </Layout.MainContainer>
    </Layout>
  );
}
